export const COUNTRIES = {
	kz: {
		id: 1,
		name: 'country.kz',
		code: 'kz',
		currency: 'gel',
		supportedLanguages: ['kk', 'ru', 'en', 'hi', 'zh', 'uz', 'tr'],
		defaultLocale: 'kk',
		fallbackLocale: 'ru'
	},
	ge: {
		id: 2,
		name: 'country.ge',
		code: 'ge',
		currency: 'gel',
		supportedLanguages: ['ka', 'ru', 'en'],
		defaultLocale: 'ka',
		fallbackLocale: 'en'
	}
};

export const getCountryByDomain = () => {
	const countryFromQuery = window.location.search.split('country=')[1];
	const cleanCountryFromQuery = countryFromQuery?.split('&')[0];

	if (cleanCountryFromQuery) {
		return (
			COUNTRIES[cleanCountryFromQuery as keyof typeof COUNTRIES] || COUNTRIES.kz
		);
	}

	const domain =
		import.meta.env.VITE_ENV === 'local'
			? 'takeaway-web.choco.ge'
			: window.location.hostname;
	const countryCode = domain.split('.').pop() as keyof typeof COUNTRIES;
	return COUNTRIES[countryCode] || COUNTRIES.kz;
};
